module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA/0lEQVRYR+2XYQ6DIAyFfTfTk82dzO1kb8EAqQy1Nd0Iif7bAvLx2r5WDI0fND5/yAAkeQFminsW614A69k3wJ4CSdqaslLuWghUe89CMAF4kRwlQfxP5ooKQLwrw2sBNocZATaHxcvcAGYF2uXAgbH8pQq0xnY7oasCm4TTxuDquuApZTNyA0gvl3A1V/1VN1xtvFTG6oRaZWs5MAJ4dw9QlTHcqpicvtaRDEaV8mkG8DySc3ce0LbjMt7eAKftuBuAWAW51AHMR2WYJiI3Baxl6J6EZgBjO5bLH+JHMCTpCeqBxMWISAaYNdblczaUdg2Q88ekgPbK3uuafx1/AAlVVzBylNG+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRCode_hover.png
// module id = E+Tr
// module chunks = 1